<template>
  <div class="cert-container">
    <!-- 顶部导航栏 -->
    <van-nav-bar
      class="custom-nav-bar"
      title="荣誉证书查询"
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
    >
      <template #right>
        <van-icon name="wap-home" size="20" @click="goHome" />
      </template>
    </van-nav-bar>

    <!-- 主体内容 -->
    <div class="main-content">
      <!-- 证件号输入区域 -->
      <div class="input-card">
        <div class="card-header">
          <van-icon name="certificate" class="header-icon" />
          <span class="header-title">请输入证件号查询荣誉证书</span>
        </div>
        <van-field
          v-model="zjh"
          class="zjh-field"
          label="证件号"
          placeholder="请输入证件号"
          clearable
          @input="handleZjhInput"
        />
        <div class="search-btn-wrapper">
          <van-button
            type="primary"
            block
            class="search-btn"
            :disabled="zjh.trim().length === 0 || isLoading"
            @click="queryRyInfo"
          >
            <van-icon name="search" />
            查询证书
          </van-button>
        </div>
      </div>

      <!-- 证书列表 -->
      <div v-for="(item, index) in ryList" :key="index" class="cert-card">
        <div class="cert-card-header">
          <van-icon name="medal-o" class="header-icon" />
          <span class="header-title">
            {{
              ryList.length > 1
                ? "证书 " + (index + 1) + " / " + ryList.length
                : "荣誉证书"
            }}
          </span>
        </div>

        <!-- 动态遍历该条记录的所有字段 -->
        <div class="info-row">
          <span class="info-label">组别</span>
          <span class="info-value">{{ item.XMJC }}</span>
        </div>
        <div class="info-row">
          <span class="info-label">项目</span>
          <span class="info-value">{{ item.SSLXMC }}</span>
        </div>
        <div class="info-row">
          <span class="info-label">姓名</span>
          <span class="info-value">{{ item.RYINFO }}</span>
        </div>
        <div class="info-row">
          <span class="info-label">名次</span>
          <span class="info-value">{{ item.MCTXT }}</span>
        </div>

        <!-- 证书下载按钮 -->
        <div class="cert-action-group">
          <van-button
            type="primary"
            block
            class="download-btn"
            :loading="item._loading"
            :disabled="item._loading"
            @click="downloadCert(item)"
          >
            <van-icon name="medal-o" />
            查看证书
          </van-button>
        </div>
      </div>

      <!-- 未查到提示 -->
      <div class="empty-tip" v-if="isQueried && ryList.length === 0">
        <van-icon name="records" class="empty-icon" />
        <p>未查询到该证件号对应的荣誉证书</p>
        <p class="empty-sub">请确认证件号是否正确</p>
      </div>
    </div>

    <!-- 证书图片弹出层 -->
    <van-overlay :show="!!previewUrl" @click="previewUrl = ''">
      <div class="cert-preview-wrap" @click.stop>
        <!-- 关闭按钮 -->
        <div class="cert-preview-close" @click="previewUrl = ''">
          <van-icon name="cross" />
        </div>
        <img :src="previewUrl" class="cert-preview-img" />
      </div>
    </van-overlay>

    <loading-com />
  </div>
</template>

<script>
import LoadingCom from "../commonCom/LoadingCom.vue";

// 需要隐藏的内部字段（不对用户展示）
const HIDDEN_KEYS = new Set([
  "SSID",
  "XMID",
  "RYID",
  "DWID",
  "SSLX",
  "SSLXMC",
  "XB",
  "ISQD",
  "QDSJ",
  "SR",
  "SRTXT",
  "CREATETIME",
  "MC",
  "ZSURL" // 单独展示，不走动态字段循环
]);

// 固定字段的中文标签映射
const LABEL_MAP = {
  RYXM: "姓名",
  XB_TXT: "性别",
  SFZH: "证件号",
  TEL: "手机号",
  AGE: "年龄",
  XMQC: "参赛项目",
  XMJC: "项目简称",
  DWQC: "队伍全称",
  DWJC: "队伍简称",
  队名: "俱乐部",
  比赛服尺码: "比赛服尺码"
};

// 展示顺序优先级
const KEY_ORDER = [
  "RYXM",
  "XB_TXT",
  "AGE",
  "SFZH",
  "TEL",
  "队名",
  "DWQC",
  "DWJC",
  "XMQC",
  "XMJC",
  "比赛服尺码"
];

export default {
  name: "CertGlIndex",
  components: { LoadingCom },
  data() {
    return {
      ssid: "",
      zjh: "",
      ryList: [],
      previewUrl: "", // 当前预览的证书图片地址
      isQueried: false,
      isLoading: false,
      utilPost: null
    };
  },
  created() {
    this.utilPost = this.$util.handler;
    this.ssid = this.$route.query.ssid || "";
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
    goHome() {
      const routeValue = localStorage.getItem("routeValue");
      if (routeValue) {
        this.$router.push({ path: "/" + routeValue });
      } else {
        this.$router.push({ path: "/" });
      }
    },

    // 证件号输入时过滤非法字符，并清空上次结果
    handleZjhInput(value) {
      this.zjh = value.replace(/[^A-Za-z0-9]/g, "");
      if (this.ryList.length > 0) {
        this.ryList = [];
        this.isQueried = false;
      }
    },

    // 查询证书信息（接口保持不变）
    queryRyInfo() {
      const zjh = this.zjh.trim();
      if (zjh.length === 0) {
        this.$notify({
          type: "warning",
          message: "请输入证件号",
          duration: 2000
        });
        return;
      }
      this.isLoading = true;
      this.isQueried = false;
      this.ryList = [];

      const paramData = {
        headerData: {
          ssid: this.ssid,
          op: "wapGL",
          methodName: "getCertSfzhInfo"
        },
        busData: { SFZH: zjh }
      };
      this.utilPost.paramData = paramData;
      this.utilPost
        .sendPost()
        .then(data => {
          this.isLoading = false;
          this.isQueried = true;
          if (!data.isSuccess) {
            this.$notify({ type: "danger", message: data.msg, duration: 3000 });
            return;
          }
          const list = data.content || [];
          this.ryList = list.map(item => {
            const row = Object.assign({}, item);
            this.$set(
              row,
              "XB_TXT",
              item.XB === "M" ? "男" : item.XB === "W" ? "女" : ""
            );
            this.$set(row, "_loading", false); // 按钮加载状态
            return row;
          });
        })
        .catch(() => {
          this.isLoading = false;
          this.isQueried = true;
        });
    },

    getFieldList(item) {
      const allKeys = Object.keys(item).filter(k => {
        if (k.startsWith("_")) return false;
        if (HIDDEN_KEYS.has(k)) return false;
        const v = item[k];
        if (v === null || v === undefined || v === "") return false;
        return true;
      });
      const ordered = KEY_ORDER.filter(k => allKeys.includes(k));
      const rest = allKeys.filter(k => !KEY_ORDER.includes(k));
      const sortedKeys = [...ordered, ...rest];
      return sortedKeys.map(k => ({
        key: k,
        label: LABEL_MAP[k] || k,
        value: k === "AGE" ? item[k] + " 岁" : item[k]
      }));
    },

    downloadCert(item) {
      this.$set(item, "_loading", true);
      const paramData = {
        headerData: {
          ssid: this.ssid,
          op: "wapGL",
          methodName: "downCert"
        },
        busData: item
      };
      this.utilPost.paramData = paramData;
      this.utilPost.sendDownCertPost().then(data => {
        this.$set(item, "_loading", false);
        if (!data.isSuccess) {
          this.$notify({
            type: "warning",
            message: data.msg,
            duration: 2000
          });
          return;
        }
        // 用弹出层展示证书图片
        this.previewUrl = data.content;
      });
    }
  }
};
</script>

<style scoped>
/* ====== 整体容器 ====== */
.cert-container {
  min-height: 100vh;
  background: #f5f6fa;
  font-size: 13px;
}

/* ====== 顶部导航 ====== */
.custom-nav-bar {
  background: linear-gradient(135deg, #c066a8 0%, #8b5baa 100%);
}
.custom-nav-bar >>> .van-nav-bar__title {
  color: #fff;
  font-weight: 700;
  font-size: 14px;
}
.custom-nav-bar >>> .van-nav-bar__text,
.custom-nav-bar >>> .van-icon {
  color: #fff;
}

/* ====== 主体 ====== */
.main-content {
  padding: 0.75rem;
}

/* ====== 输入卡片 ====== */
.input-card {
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 2px 12px rgba(192, 102, 168, 0.12);
  overflow: hidden;
  margin-bottom: 0.75rem;
}

.card-header {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.6rem 0.875rem;
  background: linear-gradient(135deg, #c066a8 0%, #8b5baa 100%);
}
.header-icon {
  font-size: 1rem;
  color: #fff;
}
.header-title {
  font-size: 13px;
  font-weight: 700;
  color: #fff;
}

/* ====== 证件号输入 ====== */
.zjh-field {
  border-bottom: 1px solid #f0f0f0;
}
.zjh-field >>> .van-field__label {
  color: #666;
  font-weight: 500;
  font-size: 13px;
}
.zjh-field >>> .van-field__control {
  color: #2c3e50;
  font-size: 13px;
}

.search-btn-wrapper {
  padding: 0.6rem 0.875rem;
}
.search-btn {
  background: linear-gradient(135deg, #c066a8 0%, #8b5baa 100%);
  border: none;
  border-radius: 7px;
  font-weight: 600;
  height: 2.25rem;
  font-size: 13px;
  box-shadow: 0 4px 12px rgba(192, 102, 168, 0.35);
}
.search-btn:active {
  transform: scale(0.98);
}

/* ====== 证书卡片 ====== */
.cert-card {
  background: #fff;
  border-radius: 10px;
  overflow: hidden;
  margin-bottom: 0.75rem;
  box-shadow: 0 2px 12px rgba(192, 102, 168, 0.12);
  border-left: 3px solid #c066a8;
}

.cert-card-header {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.6rem 0.875rem;
  background: linear-gradient(135deg, #c066a8 0%, #e0729a 100%);
}

/* ====== 信息行 ====== */
.info-row {
  display: flex;
  align-items: center;
  padding: 0.55rem 0.875rem;
  border-bottom: 1px solid #f5f5f5;
}
.info-label {
  flex-shrink: 0;
  width: 5rem;
  color: #6b7280;
  font-size: 12px;
  font-weight: 500;
}
.info-value {
  flex: 1;
  color: #1f2937;
  font-size: 13px;
  font-weight: 500;
  word-break: break-all;
}

/* ====== 名次 ====== */
.rank-value {
  color: #c066a8;
  font-weight: 700;
  font-size: 14px;
}

/* ====== 证书图片预览弹出层 ====== */
.cert-preview-wrap {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 88vw;
  max-height: 80vh;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.cert-preview-close {
  align-self: flex-end;
  width: 32px;
  height: 32px;
  background: rgba(255, 255, 255, 0.9);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  color: #333;
  margin-bottom: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  cursor: pointer;
  flex-shrink: 0;
}
.cert-preview-img {
  width: 100%;
  border-radius: 10px;
  display: block;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.4);
  max-height: calc(80vh - 48px);
  object-fit: contain;
}

/* ====== 证书下载按钮 ====== */
.cert-action-group {
  padding: 0.6rem 0.875rem;
}
.download-btn {
  background: linear-gradient(135deg, #c066a8 0%, #8b5baa 100%);
  border: none;
  border-radius: 7px;
  font-weight: 700;
  height: 2.25rem;
  font-size: 13px;
  box-shadow: 0 4px 12px rgba(192, 102, 168, 0.35);
}
.download-btn:active {
  transform: scale(0.98);
}
.download-btn[disabled] {
  background: #d1d5db;
  box-shadow: none;
}

/* ====== 空提示 ====== */
.empty-tip {
  text-align: center;
  padding: 2rem 1rem;
  color: #6b7280;
}
.empty-icon {
  font-size: 2.5rem;
  color: #d1d5db;
  margin-bottom: 0.75rem;
  display: block;
}
.empty-tip p {
  margin: 0.25rem 0;
  font-size: 13px;
}
.empty-sub {
  font-size: 12px;
  color: #9ca3af;
}
</style>



// WEBPACK FOOTER //
// src/components/CertGlIndex/CertGlIndex.vue